import React, { useState } from "react";
import { Button, Card, CardBody, Container } from "reactstrap";
import ClaimRule from "./components/ClaimRule";
import DispenseFees from "./components/DispenseFees";
import OrderingConfiguration from "./components/OrderingConfiguration";
import SaveConfiguration from "./components/SaveConfiguration";
import SearchConfiguration from "./components/SearchConfiguration";
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilterLatest } from 'utils/helper';
import { useEffect } from "react";
import ConfigurationsTable from "./components/ConfigurationsTable";
import ConfigurationsTabs from "./components/ConfigurationsTabs";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import ViewConfiguration from "components/ViewConfiguration";
import ErrorBoundary from "components/ErrorBoundary";
import ChainPharmacyDetailsTab from "components/ChainPharmacyDetailsTab"
import { ref } from "yup";



let filters = [];
const Configuration = () => {
  const API = useAxios();
  const [collapseSider, setcollapseSider] = useState(false);
  const {
    states: { configurations },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, searchTerms } = configurations;
  const { thirdPartyAdminID } = thirdPartyAdmin;
  const [data, setData] = useState([]);
  const [enableAdd, setEnableAdd] = useState(true);
  const [columnFilters, setColumnFilters] = useState(null);
  const [totalItem, setTotalItem] = useState(0);
  const [SelectedRow, setSelectedRow] = useState("")
  const [SelectedChainPharmacy, setSelectedChainPharmacy] = useState(undefined)
  const [selectChainPharmacyName , setSelectChainPharmacyName] = useState(undefined);
  const [clientConfigtoggle, setClientCongigToggle] = useState(false);
  const [editConfigtoggle, setEditConfigToggle] = useState(false);
  const [rowconfig, setRowConfig] = useState(true);
  const [configRules, setConfigRules] = useState(false)
  const [appFilter, setAppFilter] = useState({});
  const [loading, setLoading] = useState(false)
  const [selectedRowDynamic , setSelectedRowDynamic] = useState({})
  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) {
      handleSearch(searchTerms);
    }
    setColumnFilters(null)

  }, []);

  const handleSearch = async (filter) => {
    const {
      thirdPartyAdminID,
      chainpharmacyID,
    } = filter;
    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != 'dateofservice'
      );
      filters.splice(index, 1);
    });
    // if (thirdPartyAdminID) {
    //   filters = getUpdatedFilterLatest(
    //     'ThirdPartyAdminID',
    //     parseInt(thirdPartyAdminID),
    //     filters
    //   );
    //   // setEnableAdd(false);
    // }

    var cpIds = [];
    cpIds = Array.isArray(chainpharmacyID) ? chainpharmacyID : [chainpharmacyID];
    setSelectedChainPharmacy(chainpharmacyID)
    const tableRes = document.querySelector('.table-responsive');
    // tableRes.scrollLeft = 0;
    search.filters = filters;
    search.ChainPharmacyID = cpIds;
    await fetchContractsConfig(search);
  };


  const fetchContractsConfig = async (filters) => {
    setColumnFilters(filters)
    setLoading(true)
    try {
      const { data } = await API.post(`GWConfig/Configuration/All/${searchTerms.thirdPartyAdminID || 0}`, filters, {
        hasDefaultURL: true,
      });
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false)
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false)
      }
    } catch (error) { }
  };

  // const handleExport = async () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/GWConfig/Configuration/ExportAll/${searchTerms.thirdPartyAdminID || 0}?access_token=${access_token}`;
  //   onExport(action, search);
  // };

  const handleExport = async () => {

    let filterObj = columnFilters ? columnFilters : search;


    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    // additionalCriteria.TPAId = searchTerms.thirdPartyAdminID || 0;
    // additionalCriteria.CPID = searchTerms.chainpharmacyID || 0 ; 
    filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;
    filterObj.ChainPharmacyID = [searchTerms.chainpharmacyID] || [0];
    var payload = {};
    var payload = {};
    payload.tenantID = "0";
    payload.gridCode = "ceconfiguration";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { result } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  const refetch = () => {
    handleSearch(searchTerms);
    setColumnFilters(null);
  }

  const handleReset = () => {
    setData([]);
    setTotalItem(0);
    setClientCongigToggle(false);
    setRowConfig(true);
    setConfigRules(false);
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };
  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchContractsConfig(filter);
    } else {
      fetchContractsConfig(filter);
    }
    configurations.search = { ...configurations.search, ...filter };
    setStates('configurations', configurations);
  };
  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters];
    await fetchContractsConfig(filterObj);
  };

  return (
    <div>
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top">
            <CardBody hidden={collapseSider} className="section-devider-border">
              <SearchConfiguration
                onReset={handleReset}
                clientConfigtoggle={clientConfigtoggle}
                setClientCongigToggle={setClientCongigToggle}
                rowconfig={rowconfig}
                setRowConfig={setRowConfig}
                setConfigRules={setConfigRules}
                onSearch={handleSearch}
                SelectedChainPharmacy={SelectedChainPharmacy}
                setSelectedChainPharmacy={setSelectedChainPharmacy}
                setSelectChainPharmacyName = {setSelectChainPharmacyName}
              />
            </CardBody>
          </Card>
        </div>
        {rowconfig == true ? (
          <Card className="border-0 shadow-top">
            <CardBody>
              <ConfigurationsTable
                clientConfigtoggle={clientConfigtoggle}
                setClientCongigToggle={setClientCongigToggle}
                setRowConfig={setRowConfig}
                setConfigRules={setConfigRules}
                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
                onExport={handleExport}
                refetch={refetch}
                rowconfig={rowconfig}
                filters={search}
                toggleSider={toggleSider}
                SelectedRow={SelectedRow}
                setSelectedRow={setSelectedRow}
                collapseSider={collapseSider}
                editConfigtoggle={editConfigtoggle}
                setEditConfigToggle={setEditConfigToggle}
                data={data}
                totalSize={totalItem}
              />
            </CardBody>
          </Card>
        ) : ''}



        {clientConfigtoggle == true ? (
          <>
            <ErrorBoundary>
              <ViewConfiguration
                thirdPartyAdminID={thirdPartyAdminID}
                search={search}
                searchTerms={SelectedRow}
                // tenantID={tenantID}
                setSelectedRowDynamic = {setSelectedRowDynamic}
                rowconfig={rowconfig}
                data={data}
                setRowConfig={setRowConfig}
                setConfigRules={setConfigRules}
                editConfigtoggle={editConfigtoggle}
                setEditConfigToggle={setEditConfigToggle}
                setClientCongigToggle={setClientCongigToggle}
                loading1={loading}
                refetch={refetch}
              />
            </ErrorBoundary>
          </>
        ) : (
          ""
        )}



        {clientConfigtoggle == true ? (
          <ClaimRule
          selectedRowDynamic = {selectedRowDynamic}
            refetch={refetch}
            data={data}
            search={search}
            searchTerms={searchTerms}
            appFilter={appFilter}
            onHandleReset={handleReset}
            clientConfigtoggle={clientConfigtoggle}
            setClientCongigToggle={setClientCongigToggle}
            rowconfig={rowconfig}
            setConfigRules={setConfigRules}
            setRowConfig={setRowConfig}
            SelectedRow={SelectedRow}
            setSelectedRow={setSelectedRow}
          />
        ) : (
          <></>
        )}



        {configRules == true ? (
          <>
            <ErrorBoundary>
              <ChainPharmacyDetailsTab
                thirdPartyAdminID={thirdPartyAdminID}
                selectChainPharmacyName = {selectChainPharmacyName}
                refetch={refetch}
                search={search}
                data={data}
                searchTerms={SelectedRow}
                // tenantID={tenantID}
                rowconfig={rowconfig}
                setRowConfig={setRowConfig}
                setConfigRules={setConfigRules}
                editConfigtoggle={editConfigtoggle}
                setEditConfigToggle={setEditConfigToggle}
                setClientCongigToggle={setClientCongigToggle}
              />
            </ErrorBoundary>
          </>
        ) : (
          ""
        )}


        {configRules &&
          <ConfigurationsTabs
            setConfigRules={setConfigRules}
            refetch={refetch}
            setRowConfig={setRowConfig}
            setClientCongigToggle={setClientCongigToggle}
            thirdPartyAdminID={thirdPartyAdminID}
            searchTerms={searchTerms}
            data={data}
            search={search}
            SelectedChainPharmacyvalue={SelectedChainPharmacy}

          />
        }
        {/*  */}
        {/* <hr />  */}
        {/* <DispenseFees /> */}
        {/* <hr /> */}
        {/* <OrderingConfiguration data={data}/> */}

        {/* <SaveConfiguration /> */}
      </Container>
    </div>
  );
};

export default Configuration;
